import { Link } from 'react-router-dom';

const quickCategories = [
  { label: '电影', icon: 'ri-film-line', query: 'type=电影', tone: 'primary' },
  { label: '电视剧', icon: 'ri-tv-2-line', query: 'type=电视剧', tone: 'accent' },
  { label: '国产', icon: 'ri-flag-2-line', query: 'region=国产', tone: 'secondary' },
  { label: '欧美', icon: 'ri-earth-line', query: 'region=欧美', tone: 'primary' },
  { label: '动作', icon: 'ri-boxing-line', query: 'genre=动作', tone: 'accent' },
  { label: '爱情', icon: 'ri-heart-3-line', query: 'genre=爱情', tone: 'secondary' },
  { label: '科幻', icon: 'ri-rocket-2-line', query: 'genre=科幻', tone: 'primary' },
  { label: '悬疑', icon: 'ri-spy-line', query: 'genre=悬疑', tone: 'accent' },
];

const toneMap: Record<string, { bg: string; text: string }> = {
  primary: { bg: 'bg-primary-50 group-hover:bg-primary-100', text: 'text-primary-600' },
  accent: { bg: 'bg-accent-50 group-hover:bg-accent-100', text: 'text-accent-600' },
  secondary: { bg: 'bg-secondary-100 group-hover:bg-secondary-200', text: 'text-secondary-700' },
};

export default function CategoryQuickNav() {
  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">影视分类快捷入口</h2>
            <p className="mt-1 text-sm text-foreground-500">按类型、地区快速找到你感兴趣的作品</p>
          </div>
          <Link
            to="/category"
            className="hidden cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 sm:flex"
          >
            全部分类
            <i className="ri-arrow-right-s-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8">
          {quickCategories.map((cat) => {
            const tone = toneMap[cat.tone];
            return (
              <Link
                key={cat.label}
                to={`/category?${cat.query}`}
                className="group flex cursor-pointer flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-3 py-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
              >
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-full transition-colors ${tone.bg} ${tone.text}`}
                >
                  <i className={`${cat.icon} text-xl`} />
                </span>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600">
                  {cat.label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}